export default {
  aboutServiceContent: {
    subtitle: "OUR SERVICES",

    title1: "Qualified & Professional",
    title2: "B2B Food Services",

    desc:
      "MAHAL delivers reliable, scalable, and transparent food procurement services tailored for restaurants and businesses.",

    text:
      "We work closely with verified suppliers and logistics partners to ensure consistent quality, timely delivery, and operational efficiency.",

    f1: "24/7 Scheduled Delivery",
    f2: "Expert Supplier Network",
    f3: "Quality Assured Products",
    f4: "Wide Product Availability",

    cta1: "View Services",
    cta2: "Contact Us",
  },
};